import { Badge, Card, EmptyState } from '@axioma/ui';

import { PageHeader } from '../components/PageHeader.js';

export function Risco(): JSX.Element {
  return (
    <div>
      <PageHeader
        eyebrow="Painel de risco"
        title="Casos prioritários"
        description="Top 20 matters ordenados por valor × urgência × complexidade. Tela para reuniões executivas."
      />
      <div className="px-8 py-6 space-y-3">
        <EmptyState
          title="Nenhum matter classificado para risco"
          description="O score é calculado automaticamente conforme matters são abertos e movimentos chegam. Cadastre o primeiro processo para começar."
        />
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
          {/* Estrutura preparada para top 20 — populada via /matters?orderBy=riskScore quando houver dados */}
          {[].map((m: { id: string; title: string; riskScore: number }) => (
            <Card key={m.id} accentLeft="critical">
              <div className="px-5 py-4">
                <Badge variant="critical">Risco {m.riskScore.toFixed(0)}</Badge>
                <h3 className="font-display text-sm text-ax-text-primary tracking-tight mt-2">
                  {m.title}
                </h3>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
